import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useTranslation } from "react-i18next";
import { Box, Grid2 } from "@mui/material";
import "moment/locale/hu";
import { OcStateChip } from "oc/components";

interface MyLeaveCalendarEvent {
  title: string;
  typeName: string;
  start: Date | string;
  end: Date | string;
  originalStart?: string;
  originalEnd?: string;
  workDays: number;
  state: string;
}

export const MyLeaveCalendarEventTooltip = ({
  event,
}: {
  event: MyLeaveCalendarEvent;
}) => {
  const { t } = useTranslation();
  let type = t(event.typeName);
  // Use original dates if available (to avoid showing BigCalendar's +1 day adjustment)
  let start = new Date(event.originalStart || event.start).toLocaleDateString();
  let end = new Date(event.originalEnd || event.end).toLocaleDateString();

  return (
    <div
      style={{
        width: 242,
        minWidth: 242,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "12px 8px 12px 8px",
      }}
    >
      <span
        style={{
          color: "#fff",
          fontSize: 16,
          letterSpacing: 0.44,
          marginBottom: 2,
        }}
      >
        {event.title}
      </span>
      <span
        style={{
          color: "#919699",
          fontSize: 14,
          letterSpacing: 0.44,
          marginBottom: 3,
        }}
      >
        {t(`MY_LEAVE_${type}`)}
      </span>
      <div
        style={{ width: "100%", height: 8, borderBottom: "1px solid #A6ADAF" }}
      />
      <span
        style={{
          fontSize: 12,
          letterSpacing: 0.4,
          color: "#fff",
          paddingTop: 8,
        }}
      >{`${start} - ${end}`}</span>
      <Grid2
        container
        spacing={2}
        style={{ fontSize: 12, paddingTop: 6, width: "100%" }}
      >
        <Grid2
          size={{ xs: 6, sm: 6, md: 6, lg: 6 }}
          style={{ textAlign: "right", textTransform: "capitalize" }}
        >
          {t("OC_WORKDAYS")}
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6 }}> {event.workDays}</Grid2>
      </Grid2>
      <Grid2 container spacing={2} style={{ fontSize: 12, paddingTop: 6 }}>
        <Grid2
          size={{ xs: 6, sm: 6, md: 6, lg: 6 }}
          style={{ textAlign: "right" }}
        >
          {t("OC_STATE")}
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
          <Box>
            <OcStateChip
              label={t(`MY_LEAVE_${event?.state.toUpperCase()}`)}
              state={
                event?.state as
                  | "requested"
                  | "approved"
                  | "rejected"
                  | "recorded"
                  | "assigned"
                  | "cancelled"
              }
              loading={false}
              variant="caption"
              tooltip={true}
            />
          </Box>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default MyLeaveCalendarEventTooltip;
